/* Header JS — header fixo (position: fixed via CSS), estado ao rolar */

if (!customElements.get('header-component')) {
    customElements.define(
        'header-component',
        class extends HTMLElement {
            connectedCallback() {
                this.header = this.querySelector('header');
                this.headerGroup = document.querySelector('.shopify-section-group-header-group');
                this.announcementSection = document.getElementById('shopify-section-announcement-bar');
                this.isIndex = document.body.classList.contains('template--index');

                this.onScroll = this.handleScroll.bind(this);
                this.onResize = this.updateSiteHeaderOffset.bind(this);

                this.updateSiteHeaderOffset();
                window.addEventListener('scroll', this.onScroll, { passive: true });
                window.addEventListener('resize', this.onResize);
                this.handleScroll();
                this.setupSearchToggle();
            }

            disconnectedCallback() {
                window.removeEventListener('scroll', this.onScroll);
                window.removeEventListener('resize', this.onResize);
            }

            updateSiteHeaderOffset() {
                var offset = this.headerGroup ? this.headerGroup.offsetHeight : 0;
                document.documentElement.style.setProperty('--site-header-offset', offset + 'px');
                document.documentElement.style.setProperty('--header-bottom', offset + 'px');

                var main = document.getElementById('MainContent');
                if (main && !this.isIndex) {
                    main.style.paddingTop = offset + 'px';
                }
            }

            handleScroll() {
                var scrolled = (window.pageYOffset || document.documentElement.scrollTop) > 16;

                if (this.headerGroup) {
                    this.headerGroup.classList.toggle('is-scrolled', scrolled);
                }

                this.classList.toggle('is-scrolled', scrolled);

                if (this.announcementSection && this.isIndex) {
                    this.announcementSection.classList.toggle('announcement-bar-hidden', scrolled);
                }
            }

            setupSearchToggle() {
                var self = this;
                var searchToggle = this.querySelector('#search-toggle');
                var searchModal = document.querySelector('#SearchModal');

                if (searchToggle && this.header) {
                    searchToggle.addEventListener('change', function() {
                        if (window.innerWidth >= 1024) {
                            this.checked = false;
                            return;
                        }

                        if (this.checked) {
                            self.header.classList.add('search-open');
                            if (searchModal && searchModal.isOpen()) {
                                searchModal.close();
                            }
                        } else {
                            self.header.classList.remove('search-open');
                        }
                    });
                }
            }
        }
    );
}

(function() {
    document.addEventListener('DOMContentLoaded', function() {
        var menuToggle = document.getElementById('menu-toggle');
        var mobileMenu = document.querySelector('.header__mobile-menu');
        var overlay = document.querySelector('.header__mobile-menu__overlay');

        if (menuToggle && mobileMenu && overlay) {
            menuToggle.addEventListener('change', function() {
                if (this.checked) {
                    mobileMenu.classList.add('is-open');
                    overlay.classList.add('is-visible');
                } else {
                    mobileMenu.classList.remove('is-open');
                    overlay.classList.remove('is-visible');
                }
            });

            overlay.addEventListener('click', function() {
                menuToggle.checked = false;
                mobileMenu.classList.remove('is-open');
                overlay.classList.remove('is-visible');
            });
        }
    });
})();
